import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/siteAnalytics';

/**
 * Fires a first party page view on every route change that lands on a public
 * marketing route. Renders nothing and never blocks. Authenticated app routes
 * are filtered out inside trackPageView by an explicit allowlist.
 */
const SiteAnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname);
  }, [location.pathname]);

  return null;
};

export default SiteAnalyticsTracker;
